/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import styled from 'styled-components';

interface TopTriggerIconsProps {
    pollutantIconWidth: number;
    pollutantIconHeight: number;
    gaugeColor: string;
}

export const TopTriggerIcon = ({ pollutantIconWidth, pollutantIconHeight, gaugeColor }: TopTriggerIconsProps) => {
    if (!gaugeColor) {
        return null;
    }

    return (
        <PollutantIconContainer 
            pollutantIconWidth={pollutantIconWidth} 
            pollutantIconHeight={pollutantIconHeight}
            gaugeColor={gaugeColor} />
    );
};

interface PollutantIconContainerProps {
    gaugeColor: string;
    pollutantIconWidth: number;
    pollutantIconHeight: number;
}
const PollutantIconContainer = styled.span<PollutantIconContainerProps>`
    display: flex;
    flex-direction: column;
    width: ${({ pollutantIconWidth }) => pollutantIconWidth ? `${pollutantIconWidth}px` : '100%' };
    height: ${({ pollutantIconHeight }) => pollutantIconHeight ? `${pollutantIconHeight}px` : '100%'};
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    ${({ gaugeColor }) =>  gaugeColor && `
        background-color: ${gaugeColor};
    `}
`;
